'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdHealing = function MdHealing(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.7 33.9l6.1-6.1-6.1-6-6 6.1z m-4.3-15.5c-1 0-1.8 0.7-1.8 1.6s0.8 1.6 1.8 1.6 1.6-0.7 1.6-1.6-0.7-1.6-1.6-1.6z m-3.4 6.6c0.9 0 1.6-0.7 1.6-1.6s-0.7-1.8-1.6-1.8-1.6 0.8-1.6 1.8 0.7 1.6 1.6 1.6z m-3.4-3.4c1 0 1.8-0.7 1.8-1.6s-0.8-1.6-1.8-1.6-1.6 0.7-1.6 1.6 0.7 1.6 1.6 1.6z m-4.4-3.3l6-6.1-6-6-6.1 6.1z m7.8-3.3c-0.9 0-1.6 0.7-1.6 1.6s0.7 1.8 1.6 1.8 1.6-0.8 1.6-1.8-0.7-1.6-1.6-1.6z m9.5 5l6.7 6.6c0.6 0.7 0.6 1.8 0 2.4l-7.2 7.3c-0.3 0.3-0.7 0.4-1.2 0.4s-0.9-0.1-1.2-0.4l-6.6-6.7-6.6 6.7c-0.7 0.6-1.8 0.6-2.4 0l-7.3-7.3c-0.6-0.6-0.6-1.7 0-2.4l6.7-6.6-6.6-6.6c-0.7-0.6-0.7-1.8 0-2.4l7.2-7.2c0.3-0.3 0.8-0.4 1.2-0.4 0.5 0 0.8 0.1 1.2 0.4l6.6 6.7 6.6-6.7c0.6-0.6 1.8-0.6 2.4 0l7.2 7.2c0.6 0.6 0.6 1.8 0 2.4z' })
        )
    );
};

exports.default = MdHealing;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/healing.js
// module id = 1091
// module chunks = 36573943044255 79611799117203 213534597649335